import React, { lazy } from "react";

const LazyTemplateDetails = lazy(() => import("./TemplateDetails"));

const TemplateDetails = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyTemplateDetails {...props} />;

export default TemplateDetails;
